// --- NEW FILE: apps/website/src/stores/ui/templates.ts ---

import type { Goal, Project, Sprint, ProjectTask, UUID } from '@dopomogai/types';

/** Default object for a new Goal. */
export const NEW_GOAL_TEMPLATE: Goal = {
  _id: '', // User must define this slug
  name: '',
  description: '',
  is_manual: true,
};

/** Default object for a new Project. */
export const NEW_PROJECT_TEMPLATE: Project = {
  id: '', // The backend will generate the UUID
  name: '',
  description: '',
  status: 'Active', 
  owner_id: null,
  version: 1,
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
};

/** Factory function to create a default object for a new Sprint. */
export const NEW_SPRINT_TEMPLATE = (projectId: UUID): Sprint => ({
  id: '', // Backend generated
  project_id: projectId,
  name: 'New Sprint',
  goal: '',
  status: 'Planning',
  start_date: new Date().toISOString(),
  end_date: new Date(new Date().setDate(new Date().getDate() + 14)).toISOString(),
  version: 1,
  tracked_goal_ids: [],
  kpi_objectives: [],
});

/** Factory function to create a default object for a new Task. */
export const NEW_TASK_TEMPLATE = (context: { projectId: UUID; sprintId?: UUID | null }): ProjectTask => ({
  _id: '', // User must define this slug
  project_id: context.projectId,
  sprint_id: context.sprintId || null,
  title: '',
  description: '',
  status: 'todo',
  task_type: 'feature',
  points: 1,
  assignee_ids: [],
  links: [],
  version: 1,
  created_at: new Date().toISOString(), // This is a client-side temporary timestamp
  updated_at: new Date().toISOString(),
});